import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

const ScrollRestoration = ({ location, children }) => {
    useEffect(() => window.scrollTo(0, 0), [location]);

    return children;
};

ScrollRestoration.propTypes = { location: PropTypes.object, children: PropTypes.any };

export default withRouter(ScrollRestoration);
